import { render, staticRenderFns } from "./StorageTags.vue?vue&type=template&id=49276a26&"
import script from "./StorageTags.vue?vue&type=script&lang=js&"
export * from "./StorageTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports